import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import './index.scss';

const container = document.getElementById('root');

const root = createRoot(container ?? (() => {

  throw new Error('Root container not found');

})());

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
